<template lang="pug">
div
  v-app(:dark='isDarkTheme' :class='appClass')
    Navbar(v-if='isNavbarShow')
    v-content
      v-container(:fill-height='!isNavbarShow' :fluid='isContainerFluid' :style='containerStyle')
        router-view(:key="$route.path")
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { login } from '@/mixins/login'

export default {
  name: 'App',
  metaInfo () {
    const name = this.$store.getters.schoolName || '樂台計畫'
    return {
      titleTemplate: `%s | ${name}`,
    }
  },
  components: {
    Navbar,
  },
  created () {
    this.checkLogin()
    this.initPreference()
  },
  mounted () {
    this.$store.commit('setOnScroll')
  },
  methods: {
    handleCheckLogin () {
      const lastUpdate = this.$store.state.userInfoLastUpdate
      if (+new Date() - lastUpdate > 5 * 60 * 1000) {
        this.checkLogin()
        this.$store.commit('setUserInfoLastUpdate')
      }
    },
    initPreference () {
      this.$store.commit('initPreference')
    },
  },
  computed: {
    isContainerFluid () {
      return ['form'].some(name => this.$route.name === name)
    },
    containerStyle () {
      return this.isMobileForm
        ? { paddingLeft: 0, paddingRight: 0 }
        : {}
    },
    isLoginPage () {
      return this.$route.name === 'login'
    },
    isNavbarShow () {
      return !this.isLoginPage
    },
    appClass () {
      return {
        noto: this.isUsingNotoSans,
      }
    },
    isUsingNotoSans () {
      if (this.$store.state.preference.isUsingNotoSans !== null) { return this.$store.state.preference.isUsingNotoSans } else { return true }
    },
  },
  // 監聽路由檢查登入等
  watch: {
    '$route' () {
      window.scrollTo(0, 0)
      this.handleCheckLogin()
    },
  },
  mixins: [login],
}
</script>
